import { useAuth } from '@/app/stores/auth'
import EditPersonalInformation from '@/features/admin-profile/components/EditPersonalInformation'
import { Card } from '@/shared/components/ui/Card'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/users/admin/edit-info')({
  component: RouteComponent,
})

function RouteComponent() {
  const userID = useAuth().decodedToken?.UserID ?? null;
  
  return (
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="container mx-auto px-4">
        <h1 className="text-2xl font-bold mb-6">Edit Admin Information</h1>
          <Card>
            <EditPersonalInformation userId={Number(userID)} />
          </Card>
        </div>
      </div>
  )
}
